// Tools → Coverage Checker (owner, 2026-09-21: "add the coverage checker also
// to tools"). The SAME map and "is this address in our zone?" box that
// Statistics → Coverage Map and the Leads coverage map carry — one component,
// one set of boundaries — just somewhere the office reaches in one click.
import React from 'react';
import CoverageStat from '../Statistics/CoverageStat';
import './warningLetters.css';

export default function CoverageChecker() {
    return (
        <div className="wl">
            <div className="wl__head">
                <h1 className="wl__title">Coverage Checker</h1>
                <p className="wl__sub">Search a building to see whether it is inside one of our zones — green means take it, amber means confirm with a manager.</p>
            </div>
            <div className="wl__card">
                <CoverageStat />
            </div>
        </div>
    );
}
